import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasAnyRole, normalizeRole } from '../utils/roles';

const ProtectedRoute = ({ children, roles, requiresCompanyScope = false }) => {
  // LocalStorage'dan authentication durumunu kontrol et
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userEmail = localStorage.getItem('userEmail');

  // Eğer kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!isAuthenticated || !userEmail) {
    return <Navigate to="/giris" replace />;
  }

  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const userRole = normalizeRole(userData?.role);
    const userCompanyId = userData?.companyId || '';
    const activeCompanyId = localStorage.getItem('activeCompanyId') || '';

    if (roles?.length && !hasAnyRole(userRole, roles)) {
      return <Navigate to="/anasayfa" replace />;
    }

    if (requiresCompanyScope && userRole === 'super_admin' && !activeCompanyId) {
      return <Navigate to="/anasayfa" replace />;
    }

    if (requiresCompanyScope && userRole !== 'super_admin' && !userCompanyId) {
      return <Navigate to="/anasayfa" replace />;
    }
  } catch (error) {
    return <Navigate to="/anasayfa" replace />;
  }

  // Eğer kullanıcı giriş yapmışsa, korunan sayfayı göster
  return children;
};

export default ProtectedRoute;
